import React from 'react';
import Icon from '@mdi/react';
import { mdiChartLine } from '@mdi/js';
import theme from '../theme'; 

export const BaselineIcon = size => (
  <Icon 
    size={size}
    path={mdiChartLine}
    title="Baseline"
    color={theme.white}
  />
);